export default "__VITE_ASSET__77866fb5__"